import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ManifestService } from './manifest.service';

@Injectable({ providedIn: 'root' })
export class ManifestNavigationService {
  private readonly router = inject(Router);
  private readonly manifestService = inject(ManifestService);
  private initialized = false;

  initialize(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (this.isVisitingCard(event.urlAfterRedirects)) {
          return;
        }

        const clientSlug = this.findClientSlug(this.router.routerState.snapshot.root);
        if (clientSlug) {
          this.manifestService.setClientManifest(clientSlug);
        } else {
          this.manifestService.resetToDefault();
        }
      });
  }

  private findClientSlug(route: ActivatedRouteSnapshot | null): string | null {
    let currentRoute = route;

    while (currentRoute) {
      const clientSlug = currentRoute.paramMap.get('client');
      if (clientSlug) {
        return clientSlug;
      }
      currentRoute = currentRoute.firstChild;
    }

    return null;
  }

  private isVisitingCard(url: string): boolean {
    const path = url.split(/[?#]/, 1)[0];
    return path === '/visiting-card' || path.startsWith('/visiting-card/');
  }
}
